import { useGtm } from '@gtm-support/vue-gtm';
import { useTrackingStore } from '@/stores';

export default defineNuxtPlugin(() => {
  const gtm = useGtm();
  const { initiateTrackingId } = useTrackingStore();
  const listeners = [];

  if (gtm?.id?.length) {
    const gtmListeners = createListeners(gtm);
    listeners.push(gtmListeners);
  } else {
    // eslint-disable-next-line no-console
    console.error('Missing GTM_ID');
  }

  initiateTrackingId();

  return {
    provide: {
      tracking: new Tracker(listeners),
    },
  };
});
